import type {
  BookingProposalNoteAttachmentDeleteApiData,
  BookingProposalNoteAttachmentDeleteApiResponses,
  BookingProposalNoteAttachmentsBulkCreateApiData,
  BookingProposalNoteAttachmentsBulkCreateApiResponses,
  BookingProposalNotePatchApiData,
  BookingProposalNotePatchApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';
import { noteAttachmentFilesFormData } from '../noteAttachmentFormData';

/**
 * Notes on a booking proposal. The backend has no create or delete endpoint for the notes
 * themselves (they arrive with the proposal), only edit and attachment management.
 */
export const getBookingProposalNoteUrls = {
  patchBookingProposalNote: responseEndpoint<BookingProposalNotePatchApiData, BookingProposalNotePatchApiResponses>({
    getUrl: ({ bookingProposalNoteId }) => apiUrl(`booking-proposal-notes/${bookingProposalNoteId}/`),
    getBody: ({ bookingProposalNoteId: _, ...body }) => body
  }),
  postBookingProposalNoteAttachmentsBulk: responseEndpoint<
    BookingProposalNoteAttachmentsBulkCreateApiData,
    BookingProposalNoteAttachmentsBulkCreateApiResponses
  >({
    getUrl: ({ bookingProposalNoteId }) => apiUrl(`booking-proposal-notes/${bookingProposalNoteId}/attachments/bulk/`),
    getHeaders: () => ({ 'Content-Type': 'multipart/form-data' }),
    getBody: ({ files }) => noteAttachmentFilesFormData(files),
    skipBodyTransformation: true
  }),
  deleteBookingProposalNoteAttachment: dataEndpoint<
    BookingProposalNoteAttachmentDeleteApiData,
    BookingProposalNoteAttachmentDeleteApiResponses
  >({
    getUrl: ({ bookingProposalNoteId, attachmentId }) =>
      apiUrl(`booking-proposal-notes/${bookingProposalNoteId}/attachments/${attachmentId}/`)
  })
};
